module.exports = __webpack_public_path__ + "img/mini-023.4c0187fc.jpg";